import style from './ChartContainer.module.css';

interface Props {
  size: number;
  bottomPadding: number;
  barCount?: number;
}

// Deterministic pseudo-random bar heights/delays so the skeleton looks organic without
// reshuffling on every re-render (which would happen with Math.random() in the render body).
const BAR_HEIGHT_PERCENTS = [45, 70, 55, 85, 40, 65, 90, 50, 75, 60, 35, 80, 55, 70, 45];

export const ChartSkeleton: React.FC<Props> = ({ size, bottomPadding, barCount = 15 }) => {
  const bars = Array.from({ length: barCount }, (_, i) => {
    const heightPercent = BAR_HEIGHT_PERCENTS[i % BAR_HEIGHT_PERCENTS.length];
    const delay = (i % 5) * 0.15;
    return (
      <div
        key={i}
        className={style.chartSkeletonBar}
        style={{ height: `${heightPercent}%`, animationDelay: `${delay}s` }}
      />
    );
  });

  return (
    <div className={style.chartSkeleton} style={{ width: size, height: size + bottomPadding }}>
      <div className={style.chartSkeletonBars}>{bars}</div>
      <div className={style.chartSkeletonLabel}>Loading chart…</div>
    </div>
  );
};
